import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import makeStyles from "utils/makeStyles";
import isEmpty from "lodash/isEmpty";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "inline",
  },
  paper: {
    position: "relative",
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  tableHead: {
    backgroundColor: "#ECF0F1",
  },
  headCell: {
    fontWeight: "bold",
    fontSize: "12px",
    width: "100%",
    textAlign: "center",
    lineHeight: "12px",
  },
  pagination: {
    fontSize: "10px",
  },
  tableRowSelected: {
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: "#ECF0F1",
    },
  },
  tableCell: {
    fontSize: "12px",
    marginLeft: "100px",
  },
  selected: {},
}));

const TablePaginationActions = (props, compProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0, "first");
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1, "back");
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1, "next");
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(
      event,
      Math.max(0, Math.ceil(count / rowsPerPage) - 1),
      "last"
    );
  };

  return (
    <div>
      <div
        className={classes.root}
        style={{
          paddingTop:
            compProps.selectedRecords &&
            compProps.selectedRecords.length &&
            !isEmpty(compProps.selectedRecords[0])
              ? "20px"
              : "0px",
        }}
      >
        {!compProps?.minimal && (
          <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label="first page"
            size="large">
            {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
        )}
        <IconButton
          onClick={handleBackButtonClick}
          disabled={compProps?.minimal ? !compProps?.previousPage : page === 0}
          aria-label="previous page"
          size="large">
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={
            compProps.minimal
              ? !compProps.nextPage
              : page >= Math.ceil(count / rowsPerPage) - 1
          }
          aria-label="next page"
          size="large">
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        {!compProps?.minimal && (
          <IconButton
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="last page"
            size="large">
            {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>
        )}
      </div>
      {compProps.selectedRecords &&
      compProps.selectedRecords.length &&
      !isEmpty(compProps.selectedRecords[0]) ? (
        <div style={{ display: "inline-block" }}>
          {" "}
          {compProps.selectedRecords.length} Record
          {compProps.selectedRecords.length === 1 ? "" : "s"} Selected{" "}
        </div>
      ) : null}
    </div>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default TablePaginationActions;
